import React, { useEffect, useState, useRef } from 'react';
import './FinalStep.scss';
import { BankAndAgentList } from "../InsuranceRequests";
import DynaSelectBox from "../../DynaView/DynaSelectBox";
import DynaInput from "../../DynaView/DynaInput";
import UtilsFunctions from "../../../../utils/UtilsFunctions";
// import { toast } from "react-toastify";
import Loader from "../../../Loader";

const FinalStep = ({ sendData, setSendData, paymentType, setPaymentType, paymentAmount }) => {
  const [bankAndAgentList, setBankAndAgentList] = useState({ bank: [], agent: [], fund: [] });
  const [isLoad, setIsLoad] = useState(false);
  const customerReceivedPay = sendData?.payType === "اقساط"
    ? sendData?.customerReceivedPay || "0"
    : paymentAmount || "0";
  const [bankPrice, setBankPrice] = useState(customerReceivedPay); // مقدار اولیه مبلغ بانک
  // برای قرار گرفتن اسکرول در پایین ترین حد ممکن
  const [dropdownCounter, setDropdownCounter] = useState(0);
  const finalStepRef = useRef(null);

  useEffect(() => {
    void BankAndAgentList(setBankAndAgentList, setIsLoad, setSendData);
  }, []);

  const handleBankPriceChange = (data) => {
    let newBankPrice = Number(data.customerBankPrice) || "0";

    if (newBankPrice > customerReceivedPay) return;

    setBankPrice(newBankPrice);
    setSendData({
      ...sendData,
      customerBankPrice: newBankPrice.toString(),
      customerFundPrice: (customerReceivedPay - newBankPrice).toString()
    });
  };

  useEffect(() => {
    if (paymentType === "bank") {
      setSendData((prev) => ({
        ...prev,
        customerBankPrice: customerReceivedPay.toString(),
        customerFundPrice: "0"
      }));
    } else if (paymentType === "cash") {
      setSendData((prev) => ({
        ...prev,
        customerBankPrice: "0",
        customerFundPrice: customerReceivedPay.toString()
      }));
    } else if (paymentType === "both") {
      setSendData((prev) => ({
        ...prev,
        customerBankPrice: bankPrice.toString(),
        customerFundPrice: (customerReceivedPay - bankPrice).toString()
      }));
    }
  }, [paymentType]);

  // اسکرول به پایین هر زمان که محتوای div تغییر کند
  useEffect(() => {
    if (finalStepRef.current) {
      finalStepRef.current.scrollTo({
        top: finalStepRef.current.scrollHeight,
        behavior: 'smooth'
      });
    }
  }, [sendData?.hasAgent, dropdownCounter]); // وابستگی ها برای واکنش به اسکرول صفحه

  return (
    <>
      {isLoad ? (
        <div className="insurance-final-step" ref={finalStepRef}>
          <div className='content-final-step'>
            <h5>پیش پرداخت مشتری :</h5>
            <div className="radio-buttons-container">
              <div className="radio-button">
                <label htmlFor="radio1" className="radio-button__label" style={{ padding: "0", fontWeight: "500" }}>
                  نوع پرداخت :
                </label>
              </div>

              <div className='radio-buttons'>
                <div className="radio-button">
                  <input name="radio-group1"
                    id="radio1"
                    className="radio-button__input"
                    type="radio"
                    checked={sendData?.receiveType === "default"}
                    onChange={() => setSendData({ ...sendData, receiveType: "default" })} />
                  <label htmlFor="radio1" className="radio-button__label">
                    <span className="radio-button__custom"></span>
                    مستقیم به حساب بیمه
                  </label>
                </div>

                <div className="radio-button">
                  <input name="radio-group1"
                    id="radio2"
                    className="radio-button__input"
                    type="radio"
                    checked={sendData?.receiveType === "personal-agent"}
                    onChange={() => setSendData({ ...sendData, receiveType: "personal-agent" })} />
                  <label htmlFor="radio2" className="radio-button__label">
                    <span className="radio-button__custom"></span>
                    به حساب نماینده
                  </label>
                </div>
              </div>
            </div>

            {sendData?.receiveType === "personal-agent" && (
              <>
                <div className="radio-buttons-container">
                  <div className="radio-button">
                    <label htmlFor="radio1" className="radio-button__label" style={{ padding: "0", fontWeight: "500" }}>
                      نوع واریز وجه :
                    </label>
                  </div>

                  <div className='radio-buttons'>
                    {["bank", "cash", "both"].map(type => (
                      <div className="radio-button" key={type}>
                        <input name="radio-group2"
                          id={type}
                          className="radio-button__input"
                          type="radio"
                          checked={paymentType === type}
                          onChange={() => setPaymentType(type)} />
                        <label htmlFor={type} className="radio-button__label">
                          <span className="radio-button__custom"></span>
                          {type === "bank" ? "حساب بانکی" : type === "cash" ? "نقدی" : "هر دو"}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>

                <div className={"grid-row"}>
                  {(paymentType === 'bank' || paymentType === 'both') && (
                    <>
                      <DynaSelectBox options={bankAndAgentList?.bank}
                        hasFilter={true}
                        label={"انتخاب بانک"}
                        className={"solid-dyna-input"}
                        value={sendData?.customerBankId}
                        onChange={(data) => setSendData({ ...sendData, customerBankId: data.value })} />

                      <DynaInput label={"مبلغ"}
                        name={"customerBankPrice"}
                        className={"solid-dyna-input"}
                        placeholder={"مبلغ را وارد کنید"}
                        hasComma={true}
                        value={UtilsFunctions.addCommas(paymentType === "both" ? bankPrice : customerReceivedPay)}
                        type={"text"}
                        setDataFromComponent={paymentType === "both" ? handleBankPriceChange : null}
                        disabled={paymentType !== "both"}
                      />
                    </>
                  )}

                  {(paymentType === 'cash' || paymentType === 'both') && (
                    <>
                      <DynaSelectBox options={bankAndAgentList?.fund}
                        hasFilter={true}
                        label={"انتخاب صندوق"}
                        className={"solid-dyna-input"}
                        value={sendData?.customerFundId}
                        onChange={(data) => setSendData({ ...sendData, customerFundId: data.value })} />

                      <DynaInput label={"مبلغ نقدی"}
                        name={"customerFundPrice"}
                        className={"solid-dyna-input"}
                        placeholder={"مبلغ نقدی را وارد کنید"}
                        hasComma={true}
                        value={UtilsFunctions.addCommas(paymentType === "both" ? customerReceivedPay - bankPrice : customerReceivedPay)}
                        type={"text"}
                        disabled
                      />
                    </>
                  )}
                </div>
              </>
            )}

            {sendData?.receiveType === "personal-agent" && (
              <>
                <hr />

                <h5>پیش پرداخت نماینده به شرکت بیمه :</h5>
                <div className='grid-row'>
                  <DynaSelectBox options={bankAndAgentList?.bank}
                    hasFilter={true}
                    label={"انتخاب بانک نماینده"}
                    className={"solid-dyna-input"}
                    value={sendData?.bankId}
                    onChange={(data) => setSendData({ ...sendData, bankId: data.value })} />

                  <DynaInput label={"مبلغ"}
                    name={"customerFundPrice"}
                    className={"solid-dyna-input"}
                    placeholder={"مبلغ نقدی را وارد کنید"}
                    hasComma={true}
                    value={UtilsFunctions.addCommas(sendData?.payType === "اقساط" ? sendData?.prePayment : sendData?.insurancePrice)}
                    type={"text"}
                    disabled
                  />
                </div>
              </>
            )}

            <hr />

            <div className="radio-buttons-container" style={{ padding: "0" }}>
              <label htmlFor="radioFalse" className="radio-button__label"
                style={{ padding: "0", fontWeight: "500" }}>
                بــازاریــاب :
              </label>
              <div className="radio-button">
                <input name="radio-group"
                  id="radioFalse"
                  className="radio-button__input"
                  type="radio"
                  checked={!sendData?.hasAgent}
                  onChange={() => setSendData({ ...sendData, hasAgent: false })} />
                <label htmlFor="radioFalse" className="radio-button__label">
                  <span className="radio-button__custom"></span>
                  ندارد
                </label>
              </div>

              <div className="radio-button">
                <input name="radio-group"
                  id="radioTrue"
                  className="radio-button__input"
                  type="radio"
                  checked={sendData?.hasAgent}
                  onChange={() => setSendData({ ...sendData, hasAgent: true })} />
                <label htmlFor="radioTrue" className="radio-button__label">
                  <span className="radio-button__custom"></span>
                  دارد
                </label>
              </div>
            </div>

            {sendData?.hasAgent &&
              <DynaSelectBox options={bankAndAgentList?.agent}
                hasFilter={true}
                label={"انتخاب بازاریاب"}
                className={"solid-dyna-input"}
                value={sendData?.agentId}
                onChange={(data) => setSendData({ ...sendData, agentId: data.value })}
                onOpen={() => setDropdownCounter(prev => prev + 1)} />
            }
          </div>
        </div>
      ) : <Loader />}
    </>
  );
};

export default FinalStep;